import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private isExpandedSubject = new BehaviorSubject<boolean>(false);
  isExpanded$ = this.isExpandedSubject.asObservable();

  toggleSidebar() {
    const newValue = !this.isExpandedSubject.value;
    this.isExpandedSubject.next(newValue);
    this.toggleBodyScroll(newValue);
  }

  private toggleBodyScroll(isExpanded: boolean) {
    if (typeof document !== 'undefined') {
      if (isExpanded) {
        document.body.classList.add('sidebar-open');
      } else {
        document.body.classList.remove('sidebar-open');
      }
    }
  }
} 